import { IconButton, InputAdornment, SvgIcon } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import React, { FunctionComponent, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@Components/TextField';
import TimePickerCustomProps from '@Components/TimePickerCustom/TimePickerCustom.types';
import Icons from '@Constants/Icons.constants';
import { ReactHookFormError } from '@Typings/global.types';

const TimePickerCustom: FunctionComponent<TimePickerCustomProps> = (
  props: TimePickerCustomProps
): JSX.Element => {
  const [open, setOpen] = useState(false);
  const { disabled, label, name, size } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleTogglePicker = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, value, ...resField } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            open={open}
            label={label}
            onClose={() => setOpen(false)}
            value={value as Date}
            disabled={disabled}
            onChange={(e: Date | null) => {
              resField.onChange(e);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: '100%' }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ m: '0' }}>
                      <IconButton
                        onClick={handleTogglePicker}
                        sx={{ mr: '0.5rem' }}
                      >
                        <SvgIcon>{Icons.timePicker}</SvgIcon>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={!!errors[name]}
                helperText={(errors[name] as ReactHookFormError)?.message}
                size={size}
              />
            )}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default TimePickerCustom;
